import script from "./info_form.vue?vue&type=script&lang=js"
export * from "./info_form.vue?vue&type=script&lang=js"

const __exports__ = script;

export default __exports__